<template>
  <div class="spinner-container" v-if="loading">
    <div class="spinner"></div>
    <div class="loading-text">
      <div v-if="message && message.length > 0">
        {{ message }}
        <div v-if="percentual && percentual > 0">
          Il caricamento è al {{ percentual }}%
        </div>
      </div>
      <div v-else>
        Caricamento in corso...
        <div v-if="percentual && percentual > 0">
          Il caricamento è al {{ percentual }}%
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadedComponent",
  props: ["loading", "percentual", "message"],
  components: {},
};
</script>
<style>
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.spinner {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin-top: 10px;
  font-size: 18px;
  color: #333;
  text-align: center;
}
</style>